<template>
    
    <div
        v-if="isInNavPill"
        id="NavPillFavButton"
        class="nav-pill display-flex-center" 
        :class="{ selected: !!isFav, disabled: favDisabled }"
        @click="$emit('toggleFavThis', $event)"
    >
        <div class="btn-fav small nav-pill-margin"></div>
    </div>
    <div
        v-else
        :class="{ selected: !!isFav, disabled: favDisabled }">
        <div @click="$emit('toggleFavThis', $event)">
            <IconMode>
                <template #default="{ index }">
                    <img src="@static/images/icons/aspn_icon/social_media/icon_favourite_disabled.png" v-if="index === 'lightWebapp' && !isFav && favDisabled" class="fav-icon" />
                    <img src="@static/images/icons/aspn_icon/social_media/icon_favourite_disabled_dark.png" v-else-if="index === 'darkWebapp' && !isFav && favDisabled" class="fav-icon" />
                    <img src="@static/images/icons/aspn_icon/social_media/icon_favourite.png" v-else-if="index === 'lightWebapp' && !isFav" class="fav-icon" />
                    <img src="@static/images/icons/aspn_icon/social_media/icon_favourite_dark.png" v-else-if="index === 'darkWebapp' && !isFav" class="fav-icon" />
                    <img src="@static/images/icons/aspn_icon/social_media/icon_favourite_selected.png" v-else-if="index === 'lightWebapp' && isFav" class="fav-icon" />
                    <img src="@static/images/icons/aspn_icon/social_media/icon_favourite_selected_dark.png" v-else-if="index === 'darkWebapp' && isFav" class="fav-icon" />
                </template>
            </IconMode> 
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isInNavPill: {
            type: Boolean,
            default: false,
        },
        isFav: {
            type: Boolean,
            default: false,
        },
        favDisabled: {
            type: Boolean,
            default: false,
        },
    },
}
</script>


<style scoped>
.fav-icon {
    width: 40px;
}
</style>